/* eslint-disable react-hooks/rules-of-hooks */
import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, MenuItem, Select, SelectChangeEvent, } from '@mui/material'
import React from 'react';

interface AddCategoryModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
}

export default function AddTagsModal({ open, onClose, setOpen }: AddCategoryModalProps) {
    const [Status, setStatus] = React.useState("0");
    const handleChange2 = (event: SelectChangeEvent) => {
        setStatus(event.target.value as string);
    };
    return (
        <Modal
            className="modal addCategory_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title text_center mb_30">
                        <h2>Add Tags</h2>
                        <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>

                    </div>
                    <form className="form" action="">

                        <div className="control_group">
                            <label>Group</label>
                            <Select value={Status} onChange={handleChange2}>
                                <MenuItem value={0} disabled>
                                    Select Group                                                      </MenuItem>
                                <MenuItem value={10}>Dinner</MenuItem>
                                <MenuItem value={20}>Experience Type</MenuItem>

                            </Select>
                        </div>
                        <div className="control_group">
                            <label>Tag Name</label>
                            <TextField placeholder="Enter Category Name" fullWidth hiddenLabel></TextField>
                        </div>
                        <div className="footer_btn_flex">

                            <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal >
    )
}
